// Shared persistence contract. Paths refer to the unchanged source hierarchy,
// never a generated Asset, DOM node, material slot or transient Three UUID.
function normalizeModelParts(parts) {
  if (!Array.isArray(parts) || parts.length > 512) throw new Error('Use at most 512 model object overrides.');
  const paths = new Set();
  return parts.map(part => {
    if (!part || Object.keys(part).some(key => !['path','position','rotation','scale','color','visible'].includes(key)) || !/^(?:\d{1,5}\/){0,15}\d{1,5}$/.test(part.path || '') || paths.has(part.path)) throw new Error('Use unique source object paths and supported object properties.');
    paths.add(part.path); const result = {path:part.path};
    for (const key of ['position','rotation','scale']) if (part[key] !== undefined) {
      const values = part[key], limit = key === 'rotation' ? 200 * Math.PI : key === 'scale' ? 10000 : 1e7;
      if (!Array.isArray(values) || values.length !== 3 || values.some(value => typeof value !== 'number' || !Number.isFinite(value) || Math.abs(value) > limit || (key === 'scale' && value < .0001))) throw new Error('Use finite model object transforms within the scene budget.');
      result[key] = [...values];
    }
    if (part.color !== undefined) { if (part.color !== null && !/^#[0-9a-f]{6}$/i.test(part.color)) throw new Error('Choose a supported object colour.'); result.color = part.color; }
    if (part.visible !== undefined) { if (typeof part.visible !== 'boolean') throw new Error('Object visibility must be boolean.'); result.visible = part.visible; }
    return result;
  });
}
function listModelParts(scene) {
  const parts = [];
  const visit = (parent, prefix = '') => parent.children.forEach((child,index) => {
    const path = prefix ? prefix + '/' + index : String(index);
    if (child.geometry) parts.push({path,name:child.name || 'Object ' + (parts.length + 1),position:child.position.toArray(),rotation:[child.rotation.x,child.rotation.y,child.rotation.z],scale:child.scale.toArray()});
    visit(child,path);
  });
  visit(scene); return parts;
}
module.exports = {normalizeModelParts,listModelParts};
